import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Popconfirm, message } from 'antd'
import _ from 'lodash'
import { request } from '../../utils/http'
import ShowModal from '../ShowModal'
import HasPermission from '../HasPermission'
import config from '../../config/custom'

import './index.css'

class ActionButtons extends Component {

    remove() {
        request(`${config.baseUrl}/${this.props.model}/${this.props.id}`, {
            method: 'DELETE'
        })
            .then(() => {
                message.success('Removed')
            })
            .catch(() => {
                // 
            })
    }

    render() {
        const props = _.pick(this.props, ['model', 'id', 'belongsTo', 'customerId'])

        return (
            <Fragment>
                <HasPermission name={'Ver'}>
                    <ShowModal
                        type="detail"
                        model={this.props.model}
                        id={this.props.id}
                        disabled={this.props.disabled}
                    >
                        <Button>
                            <Icon type="eye" />
                        </Button>
                    </ShowModal>
                </HasPermission>
                {
                    !this.props.disabled &&
                    <Fragment>
                        <HasPermission name={'Editar'}>
                            <ShowModal type="form" {...props}>
                                <Button className="action-button">
                                    <Icon type="edit" />
                                </Button>
                            </ShowModal>
                        </HasPermission>
                        <HasPermission name={'Borrar'}>
                            <Popconfirm title={`Remove ${this.props.model}?`}
                                onConfirm={() => { this.remove() }}
                                okText="Ok"
                                cancelText="Cancel">
                                <Button className="action-button" disabled={!!this.props.disableDelete} ><Icon type="delete" /></Button>
                            </Popconfirm>
                        </HasPermission>
                    </Fragment>
                }
            </Fragment>
        )
    }
}

ActionButtons.propTypes = {
    model: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    belongsTo: PropTypes.object
}

export default ActionButtons



// WEBPACK FOOTER //
// ./src/containers/ActionButtons/index.js